// import api from '/common/js/api.js';
// import configApi from '/src/common/config/api.js';
import { get, set } from 'idb-keyval';
import { getToolRelatedCategory, addNewCategory } from '@/api/model_resource';
const state = {
    categories: {
        专业分类: [],
        行业分类: [],
        功能分类: [],
        模型分类: [],
        模型文件类型: []
    },
    snackbar: {
        show: false,
        text: '',
        color: '',
    },
    taskInfo: '',  //任务信息
}

const SUCCESS = 200;
const actions = {
    setMap({ commit }, obj) {
        commit('SETMAP', obj);
    },
    async refreshCategories({ commit }) {
        const catInCache = await get('categories');

        if (catInCache == null) {
            // const map = configApi.getToolRelatedCategory();
            // api.$axios(map).then(res => {
            //     if (res.status === SUCCESS) {
            //         console.log(res.data.data)
            //         set('categories', res.data.data);
            //         commit('REFRESH_CATEGORY', res.data.data);
            //     }
            // })
            getToolRelatedCategory().then((res) => {
                if (res.status === SUCCESS) {
                    console.log(res.data)
                    set('categories', res.data);
                    commit('REFRESH_CATEGORY', res.data);
                }
            })
        } else {
            commit('REFRESH_CATEGORY', catInCache);
        }

    },
    addCategory({ commit }, obj) {
        // const map = configApi.addNewCategory(obj);
        // api.$axios(map).then(res => {
        //     if (res.status === SUCCESS) {
        //         commit('ADD_CATEGORY', obj);
        //     }
        // })
        addNewCategory(obj).then((res) => {
            if (res.status === SUCCESS) {
                commit('ADD_CATEGORY', obj);
            }
        })
    },
    updateTaskInfo({ commit }, task) {
        commit('UPDATE_TASK', task)
    },
    showWarningMsg({ commit }, text) {
        commit('SHOW_SNACKBAR', { color: 'warning', text, })
    },
    showSuccessMsg({ commit }, text) {
        commit('SHOW_SNACKBAR', { color: 'success', text, })
    }
};


// getters
const getters = {
}

const mutations = {
    SETMAP(state, obj) {
        state[obj.key] = obj.value;
    },
    REFRESH_CATEGORY(state, obj) {
        state.categories = obj;
    },
    ADD_CATEGORY(state, obj) {
        state.categories[obj.type].push(obj.name);
    },
    UPDATE_TASK(state, task) {
        state.taskInfo = task;
    },
    SHOW_SNACKBAR(state, { color, text }) {
        state.snackbar.show = true
        state.snackbar.color = color
        state.snackbar.text = text
    },
    HIDE_SNACKBAR(state) {
        state.snackbar.show = false
    },
    SET_TASKINFO: (state, data) => {
        state.taskInfo = data
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
}